import { createRouter, createWebHistory } from 'vue-router'

const ClientBillingPage = () => import('views/ClientBillingPage.vue')
const ClientHome = () => import('views/ClientHomePage.vue')
const ClientOrdersPage = () => import('views/ClientOrdersPage.vue')
const ClientMarketplaceCheckoutPage = () => import('views/ClientMarketplaceCheckoutPage.vue')
const ClientMarketplacePage = () => import('views/ClientMarketplacePage.vue')
const ClientMyPantryPage = () => import('views/ClientMyPantryPage.vue')
const ClientReportsPage = () => import('views/ClientReportsPage.vue')
const ClientReportsPageAccountSpend = () => import('views/ClientReportsPageAccountSpend.vue')
const ClientReportsPageProductPerformance = () => import('views/ClientReportsPageProductPerformance.vue')
const ClientReportsPageCategorySpend = () => import('views/ClientReportsPageCategorySpend.vue')
const ClientReportsPageProductSpend = () => import('views/ClientReportsPageProductSpend.vue')
const ClientReportsPageSubcategorySpend = () => import('views/ClientReportsPageSubcategorySpend.vue')
const ClientReportsPageTotalSpend = () => import('views/ClientReportsPageTotalSpend.vue')
const OperationsOverviewPage = () => import('views/OperationsOverviewPage.vue')
const ClientSettingsPage = () => import('views/ClientSettingsPage.vue')
const ClientSchedulePage = () => import('views/ClientSchedulePage.vue')
const ClientWeeklySchedule = () => import('components/ClientWeeklySchedule.vue')
const CraftyHolidayCalendar = () => import('components/CraftyHolidayCalendar.vue')
const ClientSupportPage = () => import('views/ClientSupportPage.vue')
const ClientBudgetsPage = () => import('views/ClientBudgetsPage.vue')
const ClientBudgetsSpendVsBudgetedPage = () => import('views/ClientBudgetsSpendVsBudgetedPage.vue')
const ClientBudgetsSpendAndFeesPage = () => import('views/ClientBudgetsSpendAndFeesPage.vue')
const ClientBudgetComparisonsPage = () => import('views/ClientBudgetsComparisonsPage.vue')
const ClientProductDetailsPage = () => import('views/ClientProductDetailsPage.vue')
const ClientMarketplaceOrderAgainPage = () => import('views/ClientMarketplaceOrderAgainPage.vue')

const routes = [
  {
    path: '/client/billing',
    name: 'client-billing',
    component: ClientBillingPage,
    meta: {
      allowDemoUser: true,
      title: 'Billing',
    },
  },
  {
    path: '/client/budgets',
    name: 'client-budgets',
    component: ClientBudgetsPage,
    meta: {
      allowDemoUser: true,
      title: 'Budgets',
    },
  },
  {
    path: '/client/budgets/spend_v_budgeted',
    name: 'client-budgets-spend-v-budgeted',
    component: ClientBudgetsSpendVsBudgetedPage,
    meta: {
      allowDemoUser: true,
      title: 'Budgets - Spend vs Budgeted',
    },
  },
  {
    path: '/client/budgets/spend_and_fees',
    name: 'client-budgets-spend-and-fees',
    component: ClientBudgetsSpendAndFeesPage,
    meta: {
      allowDemoUser: true,
      title: 'Budgets - Spend and Fees',
    },
  },
  {
    path: '/client/budgets/budget_comparisons',
    name: 'client-budgets-comparisons',
    component: ClientBudgetComparisonsPage,
    meta: {
      allowDemoUser: true,
      title: 'Budgets - Budget Comparisons',
    },
  },
  {
    path: '/client/orders/:id',
    name: 'client-order',
    component: ClientOrdersPage,
    props: route => ({ locationId: route.query.location_id, orderId: route.params.id }),
    meta: {
      allowDemoUser: true,
      title: `Orders`,
    },
  },
  {
    path: '/client/orders',
    name: 'client-orders-index',
    component: ClientOrdersPage,
    props: route => ({ locationId: route.query.location_id, orderId: route.params.id }),
    meta: {
      allowDemoUser: true,
      title: 'Orders',
    },
  },
  {
    path: '/client/marketplace/checkout',
    name: 'client-marketplace-checkout',
    component: ClientMarketplaceCheckoutPage,
    meta: {
      title: 'Checkout',
    },
  },
  {
    path: '/client/marketplace',
    name: 'client-marketplace',
    component: ClientMarketplacePage,
    meta: {
      allowDemoUser: true,
      allowLoggedOutUser: true,
      title: 'Marketplace',
    },
  },
  {
    path: '/client/marketplace/products/:id',
    name: 'client-product-details',
    component: ClientProductDetailsPage,
    meta: {
      allowDemoUser: true,
      allowLoggedOutUser: true,
      title: 'Product Details',
    },
  },
  {
    path: '/client/marketplace/order_again',
    name: 'client-marketplace-order-again',
    component: ClientMarketplaceOrderAgainPage,
    meta: {
      title: 'Order Again',
    },
  },
  {

    path: '/client/my_pantry',
    name: 'client-my-pantry',
    component: ClientMyPantryPage,
    meta: {
      allowDemoUser: true,
      title: 'My Pantry',
    },
  },
  {
    path: '/client/analytics',
    name: 'client-reports',
    redirect: { name: 'client-total-spend-report' },
    component: ClientReportsPage,
    children: [
      {
        path: 'product_performance',
        name: 'client-product-performance-report',
        components: {
          ReportContent: ClientReportsPageProductPerformance,
        },
        meta: {
          title: 'Product Performance',
        },
      },
      {
        path: 'total_spend',
        name: 'client-total-spend-report',
        components: {
          ReportContent: ClientReportsPageTotalSpend,
        },
        meta: {
          title: 'Total Spend Report',
        },
      },
      {
        path: 'product_report',
        name: 'client-product-spend-report',
        components: {
          ReportContent: ClientReportsPageProductSpend,
        },
        meta: {
          title: 'Product Spend Report',
        },
      },
      {
        path: 'spend_by_location',
        name: 'client-account-spend-report',
        components: {
          ReportContent: ClientReportsPageAccountSpend,
        },
        meta: {
          title: 'Account Spend',
        },
      },
      {
        path: 'spend_by_category',
        name: 'client-category-spend-report',
        components: {
          ReportContent: ClientReportsPageCategorySpend,
        },
        meta: {
          title: 'Category Spend Report',
        },
      },
      {
        path: 'spend_by_subcategory',
        name: 'client-subcategory-spend-report',
        components: {
          ReportContent: ClientReportsPageSubcategorySpend,
        },
        meta: {
          title: 'Subcategory Spend Report',
        },
      },
    ],
  },
  {
    path: '/client/operations_overview',
    name: 'client-operations-overview',
    component: OperationsOverviewPage,
    meta: {
      allowDemoUser: true,
      title: 'Operations Overview',
    },
  },
  {
    path: '/client/settings',
    name: 'client-settings',
    component: ClientSettingsPage,
    meta: {
      title: 'Settings',
    },
  },
  {
    path: '/client/schedule',
    name: 'client-schedule',
    redirect: { name: 'weekly-schedule' },
    component: ClientSchedulePage,
    children: [
      {
        path: 'weekly_schedule',
        component: ClientWeeklySchedule,
        name: 'weekly-schedule',
        meta: {
          title: 'Weekly Schedule',
        },
      },
      {
        path: 'service_disruptions',
        component: CraftyHolidayCalendar,
        name: 'service-disruptions',
        meta: {
          title: 'Service Disruptions',
        },
      },
    ],
  },
  {
    path: '/client/support',
    name: 'client-support',
    component: ClientSupportPage,
    meta: {
      allowDemoUser: true,
      title: 'Support',
    },
  },
  {
    path: '/client/home',
    name: 'client-home',
    component: ClientHome,
    meta: {
      allowDemoUser: true,
      title: 'Home',
      flag: 'aiHomePageEnabled',
    },
  },
]

const appEl = document.getElementById('client-platform-vue-app')
const provided = appEl ? JSON.parse(appEl.dataset['provide']) : {}

const router = createRouter({
  routes,
  history: createWebHistory(),
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

const legacyRailsNavLinkMap = {
  'client-order': 'Orders',
  'client-orders-index': 'Orders',
  'client-marketplace': 'Marketplace',
  'client-home': 'Home',
  'client-my-pantry': 'My Pantry',
  'client-operations-overview': 'Operations',
  'client-billing': 'Billing',
  'client-settings': 'Settings',
  'client-schedule': 'Schedule',
  'weekly-schedule': 'Schedule',
  'service-disruptions': 'Schedule',
  'client-support': 'Support',
  'client-budgets': 'Budgets',
  'client-budgets-spend-v-budgeted': 'Budgets',
  'client-budgets-spend-and-fees': 'Budgets',
  'client-budgets-comparisons': 'Budgets',
  'client-product-details': 'Marketplace',
}

router.beforeEach((to, from, next) => {
  if (to.name !== from.name) {
    if (!pageViewable(to)) return next(getHomePage())
    updatePageTitle(to)
    next()
  } else {
    next()
  }
})

const pageViewable = (to) => {
  const { meta, name: route } = to
  if (!meta?.allowDemoUser && provided?.demoUser) return false
  if (meta?.allowLoggedOutUser !== true && provided?.loggedOutUser === true) return false
  if (meta?.flag && !provided?.[meta.flag]) return false
  const page = legacyRailsNavLinkMap[route]
  if (!page) return true
  if (route === getHomePage().name) return true

  const linkId = `#pendo-nav-link-${page.toLowerCase().replace(/\s+/g, '-')}`

  const el = document.querySelector(linkId)
  const viewable = !el?.classList?.contains('client-side-nav__link--disabled') || !el?.classList?.contains('client-side-nav__link--not-permissible')

  return viewable
}

const getHomePage = () => {
  if (provided?.aiHomePageEnabled)
    return { name: 'client-home' }
  else
    return { name: 'client-marketplace' }
}

const updatePageTitle = (to) => {
  const { title } = to.meta
  const defaultTitle = 'Craft a Better Workplace'

  document.title = `${title || defaultTitle}`
}

export { router }
